/** @jsx jsx */
import { Rapid } from '@composite';
import { Layout, StaticSEO } from '@core';
import { jsx } from 'theme-ui';

const AboutPage = () => (
  <Layout invertedHeader>
    <StaticSEO pageId='rapid' />
    <Rapid />
  </Layout>
);

export default AboutPage;
